module.exports = __webpack_public_path__ + "static/media/icon-report-high-score-d.ca6633fe.svg";